<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        :title="title"
        class="button shadow d-flex"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilPlus" />
        </span>
        <span class="button__text">
            <slot>
                {{ $t("edit") }}
            </slot>
        </span>
    </CButton>
</template>

<script>
import { cilPlus } from "@coreui/icons";
export default {
    name: "ButtonEdit",
    icons: {
        cilPlus,
    },
    props: {
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: "success",
        },
        disabled: Boolean,
        type: String,
        title: String,
    },
};
</script>
